<div class="d-flex tw-flex-col w-100 mb-4 tw-relative">
  <div class="d-flex justify-content-center align-items-center tw-gap-2">
    <sb-local-date-range-input
      class="mr-2 tw-z-10"
      [disabled]="loading"
      [from]="from" [till]="till"
      [showSubmit]="true"
      (dateChange)="handleDateChange($event)">
    </sb-local-date-range-input>
  </div>

  <div class="tw-relative tw-flex tw-w-full tw-justify-center tw-items-center" [style]="'height: ' + chartData.height + 'px; margin-top: -1rem;'">
    <sb-loading-spinner *ngIf="loading" class="tw-absolute"></sb-loading-spinner>
    <sb-chart
      #chart
      [chartData]="chartData"
      chartType="lineChart"
      class="tw-w-full tw-transition-opacity tw-ease-in-out tw-duration-200"
      [ngClass]="{'tw-opacity-20': loading, 'tw-hidden': !chartDataValid}"
    ></sb-chart>
    <span *ngIf="!loading && !chartDataValid" class="italic">{{'lang.globals.noData' | translate}}</span>
  </div>
</div>
